import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { IReferenceDTO } from "../../services/setpoint-administration-service/Models";
import AlarmSetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseSetpointReferenceDataParms = {
    groupID: number,
    organizationID: number,
} & BaseUseQueryParameters<IReferenceDTO | undefined>;

export function useSetpointReferenceData({
    groupID,
    organizationID,
    enabled,    
    onSuccess,
    onError
}: UseSetpointReferenceDataParms) {
    return useQuery<IReferenceDTO, RestError>(
        keys.referenceData(groupID, 
            organizationID,
        ),
        ({ signal }) => {
            return AlarmSetpointAdministrationDataService.getReferenceData(
                groupID, 
                organizationID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,

        }
    );
}